/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useLanguage } from '@orientaction/hooks';
import { Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  RadarController,
  Legend } from 'chart.js';
import { FC, useEffect, useMemo, useState } from 'react';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  RadarController,
  Filler,
  Legend
);

interface IProps {
  data: any;
  min?: number;
  max?: number;
}

const RadarDiagram: FC<IProps> = ({ data: propsData, min, max }) => {
  const { language, translateWord } = useLanguage();
  const [graphLabels, setGraphLabels] = useState<Array<string>>([]);

  const wrapLabel = (label: string, maxLength: number) => {
    const words = label.split(' ');
    const lines: string[] = [];
    let currentLine = '';
    words.forEach((word) => {
      if ((currentLine + word).length > maxLength) {
        lines.push(currentLine.trim());
        currentLine = `${word} `;
      } else {
        currentLine += `${word} `;
      }
    });
    lines.push(currentLine.trim());
    return lines;
  };

  const data = useMemo(() => {
    return {
      labels: propsData.map((el: any) => el.attributes.name),
      datasets: [
        {
          data: propsData.map((el: any) => el.totalVariableValue),
          fill: true,
          backgroundColor: '#00098c39',
          borderColor: '#000A8C',
          pointBackgroundColor: '#000A8C',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#000A8C',
        },
      ],
    };
  }, [graphLabels]);

  const options = {
    elements: {
      line: {
        borderWidth: 3,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        min,
        max,
        pointLabels: {
          font: {
            family: 'Poppins',
            size: 14,
            weight: 'bold',
          },
          color: '#000A8C', // tu peux aussi changer la couleur
          callback: (label: string) => {
            return wrapLabel(label, 12);
          },
        },
        backgroundColor: 'white',
      },
    },
  };

  return <Radar options={options} data={data} />;
};

export default RadarDiagram;
